<template>
    <div
        :class="[
            $style['modal-component'],
            containerClass,
            fullSizeOnMobile ? $style['full-size-on-mobile'] : '',
            $style[mobile ? 'mobile' : 'desktop'],
        ]"
    >
        <transition
            :enter-active-class="$style['overlay-enter']"
            :leave-active-class="$style['overlay-leave']"
        >
            <div
                :class="$style['overlay']"
                v-if="open"
                @click="setOpen(false)"
            ></div>
        </transition>
        <transition
            :enter-active-class="$style['menu-enter']"
            :leave-active-class="$style['menu-leave']"
        >
            <div
                :class="[$style['modal-content'], contentClass]"
                v-show="open"
                tabindex="0"
                ref="modalContent"
            >
                <div :class="$style['close-btn-position-left']">
                    <slot name="close-button-left"></slot>
                </div>
                <div :class="$style['close-btn-position']">
                    <slot
                        name="close-button"
                        :close="() => setOpen(false)"
                    ></slot>
                </div>
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<style module lang="scss">
.close-btn-position {
    position: absolute;
    top: 0px;
    right: 0px;
}
.close-btn-position-left {
    position: absolute;
    top: 0px;
    left: 0px;
}
body.with-side-nav-open {
    height: 100vh;
    overflow-y: hidden;
}

.overlay-enter {
    animation: overlay-animation 0.4s;
}

.overlay-leave {
    animation: overlay-animation 0.4s reverse;
}

@keyframes overlay-animation {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@import "common.css.src/layers.scss";

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: $zIndexPopups;
}

.modal-component {
    position: relative;
}

.menu-enter,
.menu-leave {
    animation-duration: 0.4s;
    animation-timing-function: cubic-bezier(0, 0, 0, 1);
    animation-delay: 0s;
    animation-iteration-count: 1;
    animation-fill-mode: none;
}

.menu-leave {
    animation-direction: reverse;
    animation-timing-function: ease-out;
}

.menu-enter,
.menu-leave {
    animation-name: menu-animation;
}

@keyframes menu-animation {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@import "common.css.src/layers.scss";

.modal-content {
    position: fixed;
    z-index: $zIndexPopupsRaised;
    background-color: #e6e6e6;
    overflow-x: hidden;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
    outline: none;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 0%);
    max-height: 80%;
    overflow-y: auto;
}

.mobile.full-size-on-mobile .modal-content {
    top: 0;
    left: 0;
    transform: none;
    height: 100vh;
    max-height: 100vh;
}

.desktop .modal-content {
    top: 10%;
    padding: 20px;
    min-width: 360px;
}

.modal-content .closebtn {
    font-weight: bold;
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}
</style>

<script lang="ts">
export default {
    model: {
        prop: "open",
    },
    data() {
        return {
            blocked: false,
        };
    },
    props: {
        containerClass: String,
        contentClass: String,
        fullSizeOnMobile: Boolean,
        mobile: Boolean,
        open: Boolean,
    },
    methods: {
        setOpen(value: boolean, force = false) {
            if (force !== true && this.blocked) return;
            this.$emit("input", value);
            if (value === true) {
                this.$emit("open");
            } else if (value === false) {
                this.$emit("close");
            }
        },
        block() {
            this.blocked = true;
        },
        unblock() {
            this.blocked = false;
        },
        setBodyClass() {
            const className = (
                this as unknown as { $style: Record<string, string> }
            ).$style["with-side-nav-open"];
            if (this.open) {
                document.body.classList.add(className);
            } else {
                document.body.classList.remove(className);
            }
        },
    },
    watch: {
        open: {
            handler() {
                this.$nextTick(function () {
                    this.setBodyClass();
                });
            },
            immediate: true,
        },
    },
    mounted() {
        document.querySelector(".body-modal-container")!.appendChild(this.$el);
    },
};
</script>
